/**
 * @packageDocumentation
 * @module f1/abstract-data-type
 */

import { t_rec_arr, t_rec, t_arr } from '../types';
import is_array from '../is/is_array';

export interface Unique {
  <V, R extends t_rec<string, V>>(adt: R): R;
  <V, R extends t_arr<V>>(adt: R): R;

  /**
   * Return duplicate-free version values (for array-like) and keys (for records)
   *
   * @public
   * @function f1.unique
   * @param adt the array or record we will eliminate unique values
   * @note for records unique is determined by key and not value
   * @example
   *
   * ```ts
   * f1.unique([16, 18, 17, 18]) === [16, 17, 18]
   * ```
   *
   */
  <V, R extends t_rec_arr<V>>(adt: R): R;
}

/**
 * @see Unique
 */
export default <V, R extends t_rec_arr<V>>(adt: R): R => {
  return is_array(adt) ? ([...new Set(adt)] as R) : adt;
};
